export const adminMixin = {
	data() {
		return {
			bottomZeroName: ['303不锈钢插销螺套'],
			bottomZeroNameKeywords: ['不卖', '原材料'],
			bottomZeroRecommendLevel: ['全国仓'],
			bottomZeroCodeKeywords: ['104458'],
			bottomZeroModelKeywords: [],
			
			keyword: '',
			loading: false,
			model: true,
			computeloading: false,
			tableData: [],
			warehouseData: [],
			days: 60,
			bottomtopratio:5,
			param: {
				// a30: 1.5,
				// a60: 0.9,
				// a90: 0.6,
				a30: 1,
				a60: 0.6,
				a90: 0.4,
				level: {
					s: {
						count: 36,
						weightingamount: 5000,
						purchasingcost: 2000,
					},
					a: {
						count: 12,
						weightingamount: 1200,
						purchasingcost: 500,
					},
					b: {
						count: 4,
						weightingamount: 200,
						purchasingcost: 80,
					},
					c: {
						count: 1,
						weightingamount: 0,
						purchasingcost: 0,
					}
				}
			},
			delta: {
				s: {
					money: 2000,
					counta: 6,
				},
				a: {
					money: 800,
					counta: 4,
				},
				b: {
					money: 400,
					counta: 4,
				},
				c: {
					money: 100,
					counta: 3,
				},
				d: {
					money: 100,
					counta: 3,
				},
			},
			percent: {
				S: {
					count: 0,
					percent: 0
				},
				A: {
					count: 0,
					percent: 0
				},
				B: {
					count: 0,
					percent: 0
				},
				C: {
					count: 0,
					percent: 0
				},
				D: {
					count: 0,
					percent: 0
				},
			}
		}
	},
	methods: {
		weightingsize(row) {
			let res = row.size30 * this.param.a30 + row.size60 * this.param.a60 + row.size90 * this.param.a90
			return res.toFixed(2)
		},
		weightingamount(row) {
			let res = row.amount30 * this.param.a30 + row.amount60 * this.param.a60 + row.amount90 * this.param.a90
			return res.toFixed(2)
		},
		purchasingcost(row) {
			let res = parseFloat(row.weightingsize) * parseFloat(row.cost)
			return res.toFixed(2)
		},
		getlevel(row) {
			let isZeroRecommendlevel = false
			this.bottomZeroRecommendLevel.forEach((item) => {
				if (row.oldlevel && row.oldlevel.indexOf(item) !== -1) {
					isZeroRecommendlevel = row.oldlevel
				}
			})
			if (isZeroRecommendlevel) {
				return isZeroRecommendlevel
			}
			let level = this.param.level
			for (let i in level) {
				if (row.count180 >= level[i].count && row.weightingamount >= level[i].weightingamount && row
					.purchasingcost >= level[i].purchasingcost) {
					return i.toUpperCase()
				}
			}
			return 'D'
			// if (row.count180 <= 0) {
			// 	return 'D'
			// } else {
			// 	return 'C'
			// }
		},
		getcorrectbottom(row) { //最大下限5不超过50kg
			let correctbottom = 999999
			if (row.weight && row.weight != 0) {
				correctbottom = parseInt(100 / row.weight)
			}
			return correctbottom
		},
		
		getbottom(row){
			let bottom = 0
			let delta = 0.6
			if(row.level == "S" ){
				bottom = Math.min( 1000 * delta / row.cost, Math.max(400 * delta / row.cost, row.weightingsize / 5) )
			}
			if(row.level == "A" ){
				bottom = Math.min( 400 * delta / row.cost, Math.max(160 * delta / row.cost, row.weightingsize / 4) )
			}
			if(row.level == "B" ){
				bottom = Math.min( 120 * delta / row.cost, row.weightingsize / 2 )
			}
			if(row.level == "C"  || row.level == "D"){
				bottom = Math.min( 40 / row.cost, Math.max(20 / row.cost, row.weightingsize / 2) )
			}
			return this.adjustBottom(row,bottom)
		},
		
		// getbottom(row) {
		// 	let bottom = 0
		// 	let money = 0
		// 	let counta = 100
		// 	for(let i in this.delta){
		// 		if(row.level == i.toUpperCase()){
		// 			money = this.delta[i].money
		// 			counta = this.delta[i].counta
		// 		}
		// 	}
		// 	row.nDaySale = row.weightingsize / counta
		// 	row.nDaySale = Math.ceil(row.nDaySale)
		// 	row.nDay = this.days / counta
			
			
		// 	if(row.level == "S" || row.level == "A"){
		// 		bottom = Math.min(money / row.tmprice, Math.max(Math.max((money / 2) / row.tmprice, (money /4) / row.cost),row.nDaySale))
		// 	}
		// 	if(row.level == "B"){
				// bottom = Math.max((money / 2) / row.tmprice, (money / 4) / row.cost) * 0.8
		// 	}
			
		// 	if(row.level == "C" || row.level == "D"){
		// 		bottom = Math.min(20 / row.cost, Math.max(Math.max((money / 2) / row.tmprice, (money / 4) / row.cost) * 1.5,row.nDaySale))
		// 	}

		
		// 	return this.adjustBottom(row,bottom)
		// },
		adjustBottom(row,bottom){
			let adjustbottom = isFinite(bottom) ? Math.ceil(bottom) : 0
			if (this.bottomZeroNameKeywords.some(keyword => row.name.includes(keyword))) {
				adjustbottom = 0
			}
			if (this.bottomZeroCodeKeywords.some(keyword => row.code.includes(keyword))) {
				adjustbottom = 0
			}		
			if (this.bottomZeroModelKeywords.some(keyword => row.model.includes(keyword))) {
				adjustbottom = 0
			}		
				
			this.bottomZeroRecommendLevel.forEach((item) => {
				if (row.level && row.level.indexOf(item) !== -1) {
					adjustbottom = 0
				}
			})
			return adjustbottom
		},
		findChildren(id) {
			return this.departmentChildren.findIndex((item) => {
				return item.id == id
			})
		},
		getBaseData() {
			this.computeloading = true
			let tableData = []
			this.$api.goods.getBaseData().then((res) => {
				let goods = res.goods
				this.warehouseData = res.warehouse
				for (let i in goods) {
					let obj = JSON.parse(goods[i])
					obj.amount30 = obj.day_30 ? obj.day_30.amount : 0
					obj.size30 = obj.day_30 ? obj.day_30.size : 0
					obj.count30 = obj.day_30 ? obj.day_30.count : 0
					obj.amount60 = obj.day_60 ? obj.day_60.amount : 0
					obj.size60 = obj.day_60 ? obj.day_60.size : 0
					obj.count60 = obj.day_60 ? obj.day_60.count : 0
					obj.amount90 = obj.day_90 ? obj.day_90.amount : 0
					obj.size90 = obj.day_90 ? obj.day_90.size : 0
					obj.count90 = obj.day_90 ? obj.day_90.count : 0
					obj.amount180 = obj.day_180 ? obj.day_180.amount : 0
					obj.size180 = obj.day_180 ? obj.day_180.size : 0
					obj.count180 = obj.day_180 ? obj.day_180.count : 0
					obj.tmprice = parseFloat(obj.tmprice) ? parseFloat(obj.tmprice) : parseFloat(obj.cost) *
						2
					obj.cost = parseFloat(obj.cost) ? parseFloat(obj.cost) : parseFloat(obj.tmprice) / 2
					tableData.push(obj)
				}
				this.tableData = tableData
				this.compute()
				this.computeloading = false
			}, () => {
				this.computeloading = false
			})
		},
		getwarehouseConfig(row) {
			let totalcount = 0
			let totalsize = 0
			let alpha = 1
			row.warehouse.forEach((item) => {
				totalcount += parseInt(item.count)
				totalsize += parseInt(item.size)
			})
			if (row.warehouse.length == 2) {
				alpha = 0.6
			}
			if (row.warehouse.length == 3) {
				alpha = 0.5
			}
			if (row.warehouse.length == 4) {
				alpha = 0.4
			}


			if (row.warehouse.length == 0) {
				row.warehouse = JSON.parse(JSON.stringify(row.oldwarehousebt))
			}
			row.warehouse.forEach((item) => {
				if (row.level == 'D') {
					// if(row.warehouse.length==1){
					// 	item.percent = 1
					// }else{
					// 	item.percent = 0.6
					// }
					item.percent = 0
					item.bottom = 0
					item.top = 0
				} else {
					if (totalcount == 0 || totalsize == 0) {
						item.percent = 0
					} else {
						item.percent = (item.count / totalcount * 0.5 + item.size / totalsize * 0.5) * row
							.warehouse.length * alpha
					}


					if (row.level == 'S' || row.level == 'A') {
						item.percent = Math.max(Math.min(item.percent, 0.8), 0.3)
					} else {
						item.percent = Math.max(Math.min(item.percent, 0.8), 0.4)
					}
					item.percent = item.percent ? item.percent : 0
					item.bottom = row.bottom * item.percent
					item.bottom = Math.min(item.bottom, row.correctbottom)
					item.bottom = Math.ceil(item.bottom)
					item.bottom = item.bottom ? item.bottom : 0

					item.top = item.bottom * this.bottomtopratio
					
					let delayday = item.getday + item.customizedday
					if (delayday && delayday > 2) {
						item.bottom = item.bottom * (1 + delayday / row.nDay)
						item.bottom = Math.ceil(item.bottom)
					}

					if (row.level == 'C') {
						item.top = Math.floor(Math.min(item.top, 500 / row.cost))
						item.top = item.top < item.bottom ? item.bottom : item.top
					}
				}

				row.oldwarehousebt.forEach((_item) => {
					if (_item.storageID == item.storageID) {
						item.oldbottom = _item.bottom
						item.oldtop = _item.top
						item.customtop = _item.customtop
						item.custombottom = _item.custombottom
						//成本 天猫价不存在 bottom=0
						if (row.level == 'C') {
							item.bottom = item.bottom ? item.bottom : item.oldbottom
							item.top = item.top ? item.top : item.oldtop
						}
					}
				})
				if (row.oldlevel == '新品') {
					if ((Math.floor(Date.now() / 1000) - row.create_time) <= 86400 * 90) {
						if (item.oldbottom >= item.bottom) {
							item.bottom = item.oldbottom
							item.top = item.oldtop
							row.level = '新品'
						}
					}
				}

				if (this.bottomZeroName.indexOf(row.name) !== -1) {
					item.percent = 0
					item.bottom = 0
					item.top = 0
				}
				if (item.bottom > item.top) {
					item.bottom = 0
					item.top = 0
				}

			})

			row.oldwarehousebt.forEach((item) => {
				let obj = row.warehouse.find((_item) => {
					return _item['storageID'] == item['storageID']
				})
				if (!obj) {
					row.warehouse.push({
						id: 0,
						code: item.goodscode,
						size: 0,
						count: 0,
						percent: 0,
						bottom: 0,
						top: 0,
						oldbottom: item.bottom,
						oldtop: item.top,
						custombottom: item.custombottom,
						customtop: item.customtop,
						storageID: item.storageID,
						storage_name: item.storage_name
					})
				}

			})
		},
		reset() {
			this.paraminit()
			this.computeloading = true
			setTimeout(() => {
				this.compute()
			}, 500)
		},
		paraminit() {
			this.param = {
				a30: 1.5,
				a60: 0.9,
				a90: 0.6,
				level: {
					s: {
						count: 24,
						weightingamount: 3000,
						purchasingcost: 1000,
					},
					a: {
						count: 12,
						weightingamount: 1200,
						purchasingcost: 500,
					},
					b: {
						count: 3,
						weightingamount: 150,
						purchasingcost: 60,
					}
				}
			}
		},
		percentinit() {
			this.percent = {
				S: {
					count: 0,
					percent: 0
				},
				A: {
					count: 0,
					percent: 0
				},
				B: {
					count: 0,
					percent: 0
				},
				C: {
					count: 0,
					percent: 0
				},
				D: {
					count: 0,
					percent: 0
				},
			}
		},
		compute() {
			this.$refs.goodsrate.clearRowExpand()
			this.percentinit()
			this.computeloading = true
			this.tableData.forEach((item) => {
				item.weightingsize = this.weightingsize(item)
				item.weightingamount = this.weightingamount(item)
				item.purchasingcost = this.purchasingcost(item)
				item.level = this.getlevel(item)
				item.correctbottom = this.getcorrectbottom(item)
				item.bottom = this.getbottom(item)
				item.top = item.bottom * this.bottomtopratio
				if (this.percent[item.level]) {
					this.percent[item.level].count++
				}

				this.getwarehouseConfig(item)
			})
			this.tableData.sort((a, b) => {
				const order = {
					"S": 0,
					"A": 1,
					"B": 2,
					"C": 3,
					"D": 4
				};
				return order[a.level] - order[b.level]
			})
			for (let i in this.percent) {
				this.percent[i].percent = (this.percent[i].count / this.tableData.length * 100).toFixed(2)
			}
			// console.log(this.tableData)


			this.computeloading = false
		},
		change() {
			this.computeloading = true
			setTimeout(() => {
				this.compute()
			}, 500)
		},
		createExportData() {
			let exportdata = []
			this.tableData.forEach((item) => {
				item.cost = isNaN(item.cost) ? '' : item.cost
				item.tmprice = isNaN(item.tmprice) ? '' : item.tmprice
				item.purchasingcost = isNaN(item.purchasingcost) ? '' : item.purchasingcost
				item.warehouse.forEach((_item) => {
					let obj = JSON.parse(JSON.stringify(item))
					obj.warehousewlnid = _item.storageID
					obj.warehousename = _item.storage_name
					obj.warehousecount = _item.count ? _item.count : 0
					obj.warehousesize = _item.size ? _item.size : 0
					obj.warehousepercnet = _item.percent
					obj.warehousegetday = _item.getday
					obj.warehousecustomizedday = _item.customizedday
					obj.warehouseoldbottom = _item.oldbottom
					obj.warehouseoldtop = _item.oldtop
					obj.warehousecustombottom = _item.custombottom
					obj.warehousecustomtop = _item.customtop

					obj.warehousebottom = Math.max(_item.custombottom, _item.bottom)
					obj.warehousetop = Math.max(_item.customtop, _item.top)



					exportdata.push(obj)
				})
			})

			return exportdata
		},


		exportdata() {
			this.loading = true
			setTimeout(() => {
				let exportdata = this.createExportData()
				exportdata.forEach((item) => {
					item.purchases = JSON.stringify(item.purchases)
				})
				this.$refs.goodsrate.exportData({
					filename: '产品评级及备货',
					type: 'xlsx',
					columns: [{
						field: 'id'
					}, {
						field: 'code'
					}, {
						field: 'name'
					}, {
						field: 'model'
					}, {
						field: 'weight'
					}, {
						field: 'cost'
					}, {
						field: 'tmprice'
					}, {
						field: 'weightingsize'
					}, {
						field: 'weightingamount'
					}, {
						field: 'purchasingcost'
					}, {
						field: 'purchases'
					}, {
						field: 'size30'
					}, {
						field: 'count180'
					}, {
						field: 'oldlevel'
					}, {
						field: 'level'
					}, {
						field: 'correctbottom'
					}, {
						field: 'bottom'
					}, {
						field: 'top'
					}, {
						field: 'duration'
					}, {
						field: 'warehousewlnid'
					}, {
						field: 'warehousename'
					}, {
						field: 'warehousecount'
					}, {
						field: 'warehousesize'
					}, {
						field: 'warehousepercnet'
					}, {
						field: 'nDay'
					}, {
						field: 'nDaySale'
					}, {
						field: 'warehousegetday'
					}, {
						field: 'warehousecustomizedday'
					}, {
						field: 'warehouseoldbottom'
					}, {
						field: 'warehouseoldtop'
					}, {
						field: 'warehousecustombottom'
					}, {
						field: 'warehousecustomtop'
					}, {
						field: 'warehousebottom'
					}, {
						field: 'warehousetop'
					}],
					data: exportdata,
				}).then(() => {
					this.loading = false
				})
			}, 500)
		},
		show() {

		},
		hide() {
			this.$emit('hide')
		},
		submit() {
			this.loading = true
			let max = 5000
			let blocks = []
			let block = []
			let exportdata = this.createExportData()
			//exportdata = this.filterSubmitData(exportdata)
			// console.log(exportdata)
			exportdata.forEach((item, index) => {
				if (block.length < max && exportdata.length - 1 > index) {
					let obj = {}
					obj.goodsid = item.id
					obj.goodscode = item.code
					obj.goodslevel = item.level
					obj.warehousewlnid = item.warehousewlnid
					obj.warehousename = item.warehousename
					obj.warehousebottom = item.warehousebottom
					obj.warehousetop = item.warehousetop
					obj.purchases = item.purchases
					obj.size30 = item.size30
					obj.process = Math.floor(Math.random() * 8)
					block.push(obj)
				} else {
					blocks.push(block)
					block = []
				}
			})
			let promise = []
			blocks.forEach((item, index) => {
				let ajax = this.$api.goods.saveResultData({
					data: item,
					index: index
				})
				promise.push(ajax)
			})
			Promise.all(promise).then(() => {
				this.$message.success('操作成功')
				this.loading = false
			})

		},
		filterSubmitData(exportdata) {

			let data = exportdata.filter((item) => {
				return item.customized == 5
			})
			return data
		}
	},
}